import React, { useState } from 'react';
import { Phone as PhoneIcon, MapPin, StarIcon, XIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-113">
      <div className="bg-white rounded-sm max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-114">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-115">
          <h2 className="text-xl font-serif text-brand-brown" data-id="element-116">{title}</h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-brand-brown transition-colors" aria-label="Cerrar" data-id="element-117">
            <XIcon className="w-5 h-5" data-id="element-118" />
          </button>
        </div>
        <div className="p-6 text-sm text-gray-600 space-y-4 leading-relaxed" data-id="element-119">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const {
    t
  } = useLanguage();
  return <>
      <footer className="bg-brand-dark text-white py-12 border-t border-brand-gold/15" data-id="element-120">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-122">
            {/* Logo Image */}
            <div className="flex-shrink-0 flex flex-col items-center gap-4" data-id="element-123">
              <img src="https://cdn.magicpatterns.com/uploads/d5PCZLxog3stu5Kmdcos9m/tairu_new_1.png" alt="Tairu Aesthetics" className="h-20 w-auto object-contain mix-blend-lighten" data-id="element-124" />
              {/* Social Icons */}
              <div className="flex items-center gap-4" data-id="element-125">
                <a href="https://www.facebook.com/katherine.ospino.95063" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-gold-light transition-colors" aria-label="Facebook" data-id="element-126">
                  <FacebookIcon className="w-5 h-5" data-id="element-127" />
                </a>
                <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-128">
                  <InstagramIcon className="w-5 h-5" data-id="element-129" />
                </a>
              </div>
              {/* Google Reviews Button */}
              <a href="https://share.google/aeNeaqJ9AadTchr2e" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-xs font-medium text-brand-gold-light hover:text-brand-gold transition-colors border border-brand-gold/30 px-3 py-1.5 rounded-sm" data-id="element-130">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-131" />
                {t('footer.reviews')}
              </a>

              {/* Accepted Payment Methods */}
              <div className="flex flex-col items-center gap-2 pt-2" data-id="element-132">
                <p className="text-[10px] text-gray-500 uppercase tracking-widest" data-id="element-133">
                  {t('footer.payments')}
                </p>
                <div className="flex items-center gap-3" data-id="element-134">
                  {/* Visa */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Visa" data-id="element-135">
                    <rect width="48" height="32" rx="4" fill="#1A1F71" data-id="element-136" />
                    <text x="24" y="20" textAnchor="middle" fill="#FFFFFF" fontSize="14" fontWeight="bold" fontFamily="Arial, sans-serif" fontStyle="italic" data-id="element-137">
                      VISA
                    </text>
                  </svg>
                  {/* Mastercard */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Mastercard" data-id="element-138">
                    <rect width="48" height="32" rx="4" fill="#2D2D2D" data-id="element-139" />
                    <circle cx="19" cy="16" r="9" fill="#EB001B" data-id="element-140" />
                    <circle cx="29" cy="16" r="9" fill="#F79E1B" data-id="element-141" />
                    <path d="M24 9.17a9 9 0 0 1 0 13.66 9 9 0 0 1 0-13.66z" fill="#FF5F00" data-id="element-142" />
                  </svg>
                  {/* American Express */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="American Express" data-id="element-143">
                    <rect width="48" height="32" rx="4" fill="#006FCF" data-id="element-144" />
                    <text x="24" y="14" textAnchor="middle" fill="#FFFFFF" fontSize="7" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-145">
                      AMERICAN
                    </text>
                    <text x="24" y="22" textAnchor="middle" fill="#FFFFFF" fontSize="7" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-146">
                      EXPRESS
                    </text>
                  </svg>
                  {/* Discover */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Discover" data-id="element-147">
                    <rect width="48" height="32" rx="4" fill="#FFFFFF" stroke="#E5E7EB" strokeWidth="0.5" data-id="element-148" />
                    <text x="24" y="14" textAnchor="middle" fill="#231F20" fontSize="6.5" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-149">
                      DISCOVER
                    </text>
                    <circle cx="24" cy="22" r="5" fill="#F47216" data-id="element-150" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Info */}
            <div className="text-center md:text-right text-sm text-gray-400 space-y-2" data-id="element-151">
              <p className="font-serif text-brand-gold-light text-lg mb-2" data-id="element-152">
                {t('footer.tagline')}
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-153">
                Phenix Salon Suite (#114), 100 Broadway, Elmwood Park, NJ 07407
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2" data-id="element-154">
                <PhoneIcon className="w-4 h-4 text-brand-gold-light" data-id="element-155" />
                <a href="tel:5513328938" className="hover:text-brand-gold-light transition-colors" data-id="element-156">
                  (551) 332-8938
                </a>
              </p>

              {/* Privacy & Terms */}
              <div className="flex items-center justify-center md:justify-end gap-4 pt-3" data-id="element-157">
                <button onClick={() => setPrivacyOpen(true)} className="text-xs text-gray-500 hover:text-brand-gold-light transition-colors underline underline-offset-2" data-id="element-158">
                  {t('footer.privacy')}
                </button>
                <span className="text-gray-600 text-xs" data-id="element-159">|</span>
                <button onClick={() => setTermsOpen(true)} className="text-xs text-gray-500 hover:text-brand-gold-light transition-colors underline underline-offset-2" data-id="element-160">
                  {t('footer.terms')}
                </button>
              </div>

              <p className="pt-4 text-xs opacity-60" data-id="element-161">
                © {new Date().getFullYear()} TAIRU AESTHETICS.{' '}
                {t('footer.rights')}
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <PolicyModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-162">
        <p data-id="element-163">
          <strong data-id="element-164">Última actualización:</strong> Mayo 2026
        </p>
        <p data-id="element-165">
          En Tairu Aesthetics, respetamos su privacidad y nos comprometemos a
          proteger su información personal. Esta política describe cómo
          recopilamos, usamos y protegemos sus datos.
        </p>
        <p data-id="element-166">
          <strong data-id="element-167">Información que recopilamos:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-168">
          <li data-id="element-169">
            Nombre, número de teléfono y correo electrónico proporcionados al
            agendar citas.
          </li>
          <li data-id="element-170">
            Información sobre su historial de tratamientos y condiciones de la
            piel.
          </li>
          <li data-id="element-171">
            Datos de navegación recopilados automáticamente (cookies, dirección
            IP).
          </li>
        </ul>
        <p data-id="element-172">
          <strong data-id="element-173">Uso de la información:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-174">
          <li data-id="element-175">Programar y gestionar sus citas.</li>
          <li data-id="element-176">Personalizar su experiencia de tratamiento.</li>
          <li data-id="element-177">
            Enviar recordatorios y comunicaciones relacionadas con sus
            servicios.
          </li>
        </ul>
        <p data-id="element-178">
          <strong data-id="element-179">Protección de datos:</strong> Implementamos medidas de
          seguridad técnicas y organizativas para proteger su información
          personal contra acceso no autorizado, pérdida o alteración.
        </p>
        <p data-id="element-180">
          <strong data-id="element-181">Sus derechos:</strong> Usted tiene derecho a acceder, corregir
          o eliminar su información personal en cualquier momento contactándonos
          al (551) 332-8938.
        </p>
        <p data-id="element-182">
          No vendemos ni compartimos su información personal con terceros para
          fines de marketing.
        </p>
      </PolicyModal>

      {/* Terms Modal */}
      <PolicyModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-183">
        <p data-id="element-184">
          <strong data-id="element-185">Última actualización:</strong> Mayo 2026
        </p>
        <p data-id="element-186">
          Al utilizar los servicios de Tairu Aesthetics, usted acepta los
          siguientes términos y condiciones:
        </p>
        <p data-id="element-187">
          <strong data-id="element-188">Citas y Cancelaciones:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-189">
          <li data-id="element-190">
            Las citas deben ser agendadas con anticipación llamando al (551)
            332-8938.
          </li>
          <li data-id="element-191">
            Solicitamos un aviso de al menos 24 horas para cancelaciones o
            reprogramaciones.
          </li>
          <li data-id="element-192">
            Las cancelaciones tardías o ausencias pueden estar sujetas a un
            cargo.
          </li>
        </ul>
        <p data-id="element-193">
          <strong data-id="element-194">Servicios:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-195">
          <li data-id="element-196">
            Todos los tratamientos comienzan con una evaluación personalizada de
            la piel.
          </li>
          <li data-id="element-197">
            Los resultados pueden variar según el tipo de piel y la condición
            individual.
          </li>
          <li data-id="element-198">
            Kate se reserva el derecho de recomendar o declinar tratamientos
            basándose en su evaluación profesional.
          </li>
        </ul>
        <p data-id="element-199">
          <strong data-id="element-200">Responsabilidad:</strong> Tairu Aesthetics no se hace
          responsable por reacciones adversas que resulten de la omisión de
          información médica relevante por parte del cliente.
        </p>
        <p data-id="element-201">
          <strong data-id="element-202">Propiedad intelectual:</strong> Todo el contenido de este
          sitio web, incluyendo imágenes, textos y diseño, es propiedad de Tairu
          Aesthetics y está protegido por las leyes de derechos de autor.
        </p>
        <p data-id="element-203">
          Para preguntas sobre estos términos, contáctenos al (551) 332-8938.
        </p>
      </PolicyModal>
    </>;
}